import Vue from "vue";

export default {
	state: {
		supplierOffers: [],
		listItensSelected: [],
		lastChildAdded: false,
		lastChildToDelete: false,
		clientKey: null
	},
	mutations: {
		setSupplierOffersOnState(state, supplierOffers) {
			state.supplierOffers = mapSupplierOffers(supplierOffers);
		},
		setListItensSelectedOnState(state, listItensSelected) {
			state.listItensSelected = listItensSelected;
		},
		addItemSelected(state, item) {
			if (state.listItensSelected.indexOf(item.idFamily) == -1) state.listItensSelected.push(item.idFamily);
		},
		deleteItemSelected(state, item) {
			if (state.listItensSelected.includes(item.idFamily)) {
				let index = state.listItensSelected.indexOf(item.idFamily);
				state.listItensSelected.splice(index, 1);
			}
		},
		cleanListObject(state) {
			state.listItensSelected.length = 0;
		},
		setClientKey(state, clientKey) {
			state.clientKey = clientKey;
		}
	},
	actions: {
		getSupplierOffers({ commit }) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("supplier/offer")
					.then((response) => {
						this.state.loading = false;
						commit("setSupplierOffersOnState", response.data.data);
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		deleteParentsOnSelectedList({ commit, dispatch, state }, item) {
			//Excluir item na lista de selecionados
			commit("deleteItemSelected", item);
			if (item.idParentFamily) {
				findParent(state.families.children, item).then((parent) => {
					dispatch("deleteParentsOnSelectedList", parent);
				});
			} else commit("setStatusOnTree");
		},
		deleteInviteOfferChildrenOnSelectedList({ commit }, item) {
			return new Promise((resolve) => {
				//Excluir item na lista de selecionados
				commit("deleteItemSelected", item);
				commit("setStatusOnTree");
				resolve();
			});
		},
		deleteInviteChildrenOnSelectedList({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				//Excluir item na lista de selecionados
				commit("deleteItemSelected", item);

				function processChildren(child) {
					dispatch("deleteInviteChildrenOnSelectedList", child).then(() => {
						let lastChild = item.children.pop();
						if (lastChild.idFamily == child.idFamily) {
							this.lastChildToDelete = true;
						}
						resolve();
					});
				}

				if (!item.children) {
					const itemData = {
						idFamily: item.idFamily,
						key: item.key
					};
					const routeName = item.key ? "getFamilyChildrensNoAuth" : "getFamilyChildrens";
					const routeParm = item.key ? itemData : item.idFamily;

					//Buscar filhos, caso não tenha ainda no front
					dispatch(routeName, routeParm).then((childrens) => {
						if (childrens)
							childrens.forEach((child) => {
								processChildren(child);
							});
					});
				} else {
					item.children.forEach((child) => {
						processChildren(child);
					});
				}

				if (this.lastChildToDelete) {
					resolve();
					commit("setStatusOnTree");
				}
				this.lastChildToDelete = false;
			});
		},
		addInviteOfferChildrenOnSelectedList({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				//Adicionar item na lista de selecionados
				commit("addItemSelected", item);
				const itemData = {
					idFamily: item.idFamily,
					key: state.clientKey
				};
				const routeName = state.clientKey ? "getFamilyChildrensNoAuth" : "getFamilyChildrens";
				const routeParm = state.clientKey ? itemData : item.idFamily;

				if (!item.childrens) {
					//Buscar filhos, caso não tenha ainda no front
					dispatch(routeName, routeParm).then((childrens) => {
						if (childrens)
							childrens.forEach((child) => {
								//Adicionar filhos na lista de selecionados
								dispatch("addInviteOfferChildrenOnSelectedList", child).then(() => {
									resolve();
								});
							});
					});
				} else {
					item.childrens.forEach((child) => {
						//Adicionar filhos na lista de selecionados
						dispatch("addInviteOfferChildrenOnSelectedList", child).then(() => {
							resolve();
						});
					});
				}
				resolve();
				commit("setStatusOnTree");
			});
		},
		addInviteChildrenOnSelectedList({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				function processChildren(child) {
					dispatch("addInviteChildrenOnSelectedList", child);
					let lastChild = item.children[item.children.length - 1];
					if (lastChild.idFamily == child.idFamily) {
						state.lastChildAdded = true;
					}
					resolve();
				}
				//Adicionar item na lista de selecionados
				commit("addItemSelected", item);

				if (item.haveChildren && !item.children) {
					const itemData = {
						idFamily: item.idFamily,
						key: item.key
					};
					const routeName = item.key ? "getFamilyChildrensNoAuth" : "getFamilyChildrens";
					const routeParm = item.key ? itemData : item.idFamily;

					//Buscar filhos, caso não tenha ainda no front
					dispatch(routeName, routeParm).then((childrens) => {
						if (childrens)
							childrens.forEach((child) => {
								processChildren(child);
							});
					});
				} else {
					item.children.forEach((child) => {
						processChildren(child);
					});
				}

				if (state.lastChildAdded) {
					resolve();
					commit("setStatusOnTree");
					state.lastChildAdded = false;
				}
			});
		},
		async createSupplierOffer(_, supplierOffer) {
			this.state.loading = true;
			return new Promise((resolve) => {
				mapSupplierOffersToBack(supplierOffer).then((mappedSupplierOffer) => {
					Vue.prototype.$http.post("offer", mappedSupplierOffer).then((response) => {
						this.state.loading = false;
						resolve(response);
					});
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		assignClientKeyByRoute({ commit }, clientKey) {
			if (clientKey) {
				commit("setClientKey", clientKey);
			}
		}
	},
	getters: {
		supplierOffers({ supplierOffers }) {
			return supplierOffers;
		},
		listItensSelected({ listItensSelected }) {
			return listItensSelected;
		}
	}
};

const mapSupplierOffersToBack = (supplierOffersToBack) => {
	return new Promise((resolve) => {
		let retObject = {
			name: supplierOffersToBack.name,
			cnpjCpf: supplierOffersToBack.cnpjCpf,
			contact: supplierOffersToBack.contact,
			email: supplierOffersToBack.email,
			message: supplierOffersToBack.message,
			family: supplierOffersToBack.family,
			company: supplierOffersToBack.companyName.map((company) => company.value)
		};
		resolve(retObject);
	});
};

const mapSupplierOffers = (companiesFromBack) => {
	let response = [];
	companiesFromBack.forEach((company) => {
		response.push(company);
	});
	return response;
};

let findParent = function (families, item) {
	return new Promise((resolve) => {
		families.forEach((family) => {
			if (family.idFamily == item.idParentFamily) {
				resolve(family);
			}
			if (family.children)
				findParent(family.children, item).then((parent) => {
					if (parent) {
						resolve(parent);
					}
				});
		});
	});
};
